(function() {

    //Formats the duration time of the YouTube video
    function formatTime(time) {
        time = Math.round(time);
        const minutes = Math.floor(time/60);
        let seconds = time - minutes * 60;
        seconds = seconds < 10 ? '0'+seconds : seconds;
        return `${minutes}:${seconds}`;
    }

    // this function gets called when API is ready to use
    function onPlayerReady(event,player,parentElement) {

        //Build and display duration of video
        const durationInSec = player.getDuration() || 0;
        const ytDuration = formatTime(durationInSec);
        let videoDurationEL = parentElement.querySelectorAll('.cmp-teaser__video-duration');
        if(videoDurationEL && videoDurationEL.length){
           parentElement.querySelectorAll('.cmp-teaser__video-duration')[0].innerText = ytDuration + ' Length';
        }

        let videoPlayButtonEl = parentElement.querySelectorAll('.cmp-teaser__video-play-button');
        if(videoPlayButtonEl && videoPlayButtonEl.length){
              //Build and display play/pause button
            videoPlayButtonEl[0].addEventListener('click', (e) => {
                videoPlayButtonEl[0].closest('.cmp-teaser').classList.add("active");
                player.playVideo();
                videoPlayButtonEl[0].parentElement.style.display = "none";
                let videoCoverEl = parentElement.querySelectorAll('.cmp-teaser__video-cover');
                if(videoCoverEl && videoCoverEl.length){
                    videoCoverEl[0].style.display = "none";
                }
            })
        }


    }

    function onYouTubeIframeAPIReady() {

        document.querySelectorAll('.cmp-teaser').forEach(function(element, index) {
            let player;
            const iframeEle =  element.querySelectorAll('.youtube-iframe');
            function playerReady(event) {
                onPlayerReady(event,player, element);
            }
            if(iframeEle && iframeEle.length) {
                const _id = iframeEle[0].getAttribute('id');
                player = new YT.Player(iframeEle[0], {
                    events:{
                        'onReady': playerReady
                    }
                })
            }

        })
    }

    document.addEventListener("DOMContentLoaded", function() {
        loadPlayer();
    });


    //Checks if the YT global variable is set in the browser, if not it will load it
    function loadPlayer() {
        if (typeof(YT) == 'undefined' || typeof(YT.Player) == 'undefined') {
            let tag = document.createElement('script');
            tag.src = "https://www.youtube.com/iframe_api";
            let firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

            window.onYouTubePlayerAPIReady = function() {
                onYouTubeIframeAPIReady();
            };
        } else {
            onYouTubeIframeAPIReady();
        }
    }
})();
